/**
 * What the composer's one action button is right now (RFC 0307 Design).
 *
 * The button never moves; what it does changes. Text always means Send, on a
 * call or not. An empty box means Stop for whatever is running: the call if
 * there is one, otherwise the agent's turn. With nothing running, an empty box
 * starts a call, when this composer has voice at all.
 */

export type ComposerAction = 'send' | 'stop-run' | 'end-call' | 'start-call'

export function composerAction(s: {
  hasDraft: boolean
  sending: boolean
  /** The agent is working and the host can stop it. */
  canStopRun: boolean
  /** This composer offers voice. */
  hasVoice: boolean
  /** A call is connecting or live. */
  onCall: boolean
}): ComposerAction {
  if (s.hasDraft || s.sending) return 'send'
  if (s.onCall) return 'end-call'
  if (s.canStopRun) return 'stop-run'
  if (s.hasVoice) return 'start-call'
  return 'send'
}
